import { NgModule } from '@angular/core';

import { AgChartsAngular } from './ag-charts-angular.component';

@NgModule({
    declarations: [],
    imports: [AgChartsAngular],
    exports: [AgChartsAngular],
})
export class AgChartsAngularModule {}
